define("settings/components/downgrade/merge-groups", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--card u--m__b" data-test-id="merge-groups">
    <table class="o--table o--table--condensed u--m__b__0">
      <thead>
        <tr>
          <th class="u--text--left">
            {{#if @hasMergedGroups}}
              <span class="u--text--success">
                {{t "account.downgrade.groups.success"}}
                {{svg-jar "check" class="o--icon"}}
              </span>
            {{else}}
              {{t "account.downgrade.groups.title"}}
            {{/if}}
          </th>
        </tr>
      </thead>
  
      <tbody>
        <tr>
          <td class="u--p__0 {{if @hasMergedGroups "u--mute"}}">
            <div class="tDG--tableScroll tDG--tableScroll--sm">
              {{#unless @hasMergedGroups}}
                <div class="o--user--lg u--block u--m__b__sm">
                  <div class="o--user__avatar cNA--group__avatar">
                    {{#if @firstGroup.imageUrl}}
                      <img class="cNA--group__avatar--img" src={{@firstGroup.imageUrl}}>
                    {{else}}
                      <span class="cNA--group__avatar--text">
                        {{word-initials @firstGroup.name}}
                      </span>
                    {{/if}}
                  </div>
                  <span class="o--user__title u--text--md u--text--light">{{@firstGroup.name}}</span>
                  <span class="o--user__desc u--text--light">
                    {{t "account.downgrade.groups.social_sets" count=@firstGroup.socialIdentitiesCount}}
                    |
                    {{@firstGroup.members.length}}
                    {{t "shared_words.users"}}
                    |
                    {{@firstGroup.mediaItemCount}}
                    {{t "account.downgrade.groups.media_items"}}
                    |
                    {{t "account.downgrade.groups.linkinbio_pages" count=@firstGroup.linkinbioPages.length}}
                  </span>
                </div>
              {{/unless}}
              {{#each @otherGroups as |group|}}
                <div class="o--user--lg u--block u--m__b__sm">
                  <div class="o--user__avatar cNA--group__avatar">
                    {{#if group.imageUrl}}
                      <img class="cNA--group__avatar--img" src={{group.imageUrl}}>
                    {{else}}
                      <span class="cNA--group__avatar--text">
                        {{word-initials group.name}}
                      </span>
                    {{/if}}
                  </div>
                  <span class="o--user__title u--text--light u--text--md {{if @hasMergedGroups "u--text--strike"}}">{{group.name}}</span>
                  <span class="o--user__desc u--text--light {{if @hasMergedGroups "u--text--strike"}}">
                    {{t "account.downgrade.groups.social_sets" count=group.socialIdentitiesCount}}
                    |
                    {{group.members.length}}
                    {{t "shared_words.users"}}
                    |
                    {{group.mediaItemCount}}
                    {{t "account.downgrade.groups.media_items"}}
                    |
                    {{t "account.downgrade.groups.linkinbio_pages" count=group.linkinbioPages.length}}
                  </span>
                </div>
              {{/each}}
            </div>
          </td>
        </tr>
      </tbody>
  
    </table>
  </div>
  
  <p class="u--text--center u--m__b">
    {{svg-jar "arrow-down" class="o--icon"}}
  </p>
  
  <div class="o--card">
    <div class="u--p__sm {{if @hasMergedGroups "" "tDG--table__highlight"}}">
      <div class="o--user--lg u--block">
        <div class="o--user__avatar cNA--group__avatar">
          {{#if @firstGroup.imageUrl}}
            <img class="cNA--group__avatar--img" src={{@firstGroup.imageUrl}}>
          {{else}}
            <span class="cNA--group__avatar--text">
              {{word-initials @firstGroup.name}}
            </span>
          {{/if}}
        </div>
        <span class="o--user__title u--text--md">{{@firstGroup.name}}</span>
        <span class="o--user__desc">
          {{t "account.downgrade.groups.social_sets" count=@account.socialSetCount}}
          |
          {{@account.users.length}}
          {{t "shared_words.users"}}
          |
          {{this.mergedGroupMediaCount}}
          {{t "account.downgrade.groups.media_items"}}
          |
          {{t "account.downgrade.groups.linkinbio_pages" count=this.linkinbioPagesCount}}
        </span>
      </div>
  
      {{#unless @hasMergedGroups}}
        <Shared::Ui::Button
          class="u--m__t"
          data-test-id="merge-groups-button"
          @type="primary"
          @additional="block"
          @text={{t "account.downgrade.groups.confirm_new_merged_group"}}
          @isDisabled={{this.isMergingGroups}}
          @onClick={{this.mergeGroups}}
        />
      {{/unless}}
  
    </div>
  </div>
  
  */
  {
    "id": "VVBZMd4j",
    "block": "[[[10,0],[14,0,\"o--card u--m__b\"],[14,\"data-test-id\",\"merge-groups\"],[12],[1,\"\\n  \"],[10,\"table\"],[14,0,\"o--table o--table--condensed u--m__b__0\"],[12],[1,\"\\n    \"],[10,\"thead\"],[12],[1,\"\\n      \"],[10,\"tr\"],[12],[1,\"\\n        \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"            \"],[10,1],[14,0,\"u--text--success\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"account.downgrade.groups.success\"],null]],[1,\"\\n              \"],[1,[28,[35,2],[\"check\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,1],[\"account.downgrade.groups.title\"],null]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"tbody\"],[12],[1,\"\\n      \"],[10,\"tr\"],[12],[1,\"\\n        \"],[10,\"td\"],[15,0,[29,[\"u--p__0 \",[52,[30,1],\"u--mute\"]]]],[12],[1,\"\\n          \"],[10,0],[14,0,\"tDG--tableScroll tDG--tableScroll--sm\"],[12],[1,\"\\n\"],[41,[51,[30,1]],[[[1,\"              \"],[10,0],[14,0,\"o--user--lg u--block u--m__b__sm\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"o--user__avatar cNA--group__avatar\"],[12],[1,\"\\n\"],[41,[30,2,[\"imageUrl\"]],[[[1,\"                    \"],[10,\"img\"],[14,0,\"cNA--group__avatar--img\"],[15,\"src\",[30,2,[\"imageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"                    \"],[10,1],[14,0,\"cNA--group__avatar--text\"],[12],[1,\"\\n                      \"],[1,[28,[35,4],[[30,2,[\"name\"]]],null]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]]],[1,\"                \"],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__title u--text--md u--text--light\"],[12],[1,[30,2,[\"name\"]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc u--text--light\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"account.downgrade.groups.social_sets\"],[[\"count\"],[[30,2,[\"socialIdentitiesCount\"]]]]]],[1,\"\\n                  |\\n                  \"],[1,[30,2,[\"members\",\"length\"]]],[1,\"\\n                  \"],[1,[28,[35,1],[\"shared_words.users\"],null]],[1,\"\\n                  |\\n                  \"],[1,[30,2,[\"mediaItemCount\"]]],[1,\"\\n                  \"],[1,[28,[35,1],[\"account.downgrade.groups.media_items\"],null]],[1,\"\\n                  |\\n                  \"],[1,[28,[35,1],[\"account.downgrade.groups.linkinbio_pages\"],[[\"count\"],[[30,2,[\"linkinbioPages\",\"length\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[42,[28,[37,6],[[28,[37,6],[[30,3]],null]],null],null,[[[1,\"              \"],[10,0],[14,0,\"o--user--lg u--block u--m__b__sm\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"o--user__avatar cNA--group__avatar\"],[12],[1,\"\\n\"],[41,[30,4,[\"imageUrl\"]],[[[1,\"                    \"],[10,\"img\"],[14,0,\"cNA--group__avatar--img\"],[15,\"src\",[30,4,[\"imageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"                    \"],[10,1],[14,0,\"cNA--group__avatar--text\"],[12],[1,\"\\n                      \"],[1,[28,[35,4],[[30,4,[\"name\"]]],null]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]]],[1,\"                \"],[13],[1,\"\\n                \"],[10,1],[15,0,[29,[\"o--user__title u--text--light u--text--md \",[52,[30,1],\"u--text--strike\"]]]],[12],[1,[30,4,[\"name\"]]],[13],[1,\"\\n                \"],[10,1],[15,0,[29,[\"o--user__desc u--text--light \",[52,[30,1],\"u--text--strike\"]]]],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"account.downgrade.groups.social_sets\"],[[\"count\"],[[30,4,[\"socialIdentitiesCount\"]]]]]],[1,\"\\n                  |\\n                  \"],[1,[30,4,[\"members\",\"length\"]]],[1,\"\\n                  \"],[1,[28,[35,1],[\"shared_words.users\"],null]],[1,\"\\n                  |\\n                  \"],[1,[30,4,[\"mediaItemCount\"]]],[1,\"\\n                  \"],[1,[28,[35,1],[\"account.downgrade.groups.media_items\"],null]],[1,\"\\n                  |\\n                  \"],[1,[28,[35,1],[\"account.downgrade.groups.linkinbio_pages\"],[[\"count\"],[[30,4,[\"linkinbioPages\",\"length\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[4]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,2],[14,0,\"u--text--center u--m__b\"],[12],[1,\"\\n  \"],[1,[28,[35,2],[\"arrow-down\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"o--card\"],[12],[1,\"\\n  \"],[10,0],[15,0,[29,[\"u--p__sm \",[52,[30,1],\"\",\"tDG--table__highlight\"]]]],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--user--lg u--block\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--user__avatar cNA--group__avatar\"],[12],[1,\"\\n\"],[41,[30,2,[\"imageUrl\"]],[[[1,\"          \"],[10,\"img\"],[14,0,\"cNA--group__avatar--img\"],[15,\"src\",[30,2,[\"imageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[14,0,\"cNA--group__avatar--text\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[[30,2,[\"name\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__title u--text--md\"],[12],[1,[30,2,[\"name\"]]],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__desc\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.downgrade.groups.social_sets\"],[[\"count\"],[[30,5,[\"socialSetCount\"]]]]]],[1,\"\\n        |\\n        \"],[1,[30,5,[\"users\",\"length\"]]],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_words.users\"],null]],[1,\"\\n        |\\n        \"],[1,[30,0,[\"mergedGroupMediaCount\"]]],[1,\"\\n        \"],[1,[28,[35,1],[\"account.downgrade.groups.media_items\"],null]],[1,\"\\n        |\\n        \"],[1,[28,[35,1],[\"account.downgrade.groups.linkinbio_pages\"],[[\"count\"],[[30,0,[\"linkinbioPagesCount\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[51,[30,1]],[[[1,\"      \"],[8,[39,7],[[24,0,\"u--m__t\"],[24,\"data-test-id\",\"merge-groups-button\"]],[[\"@type\",\"@additional\",\"@text\",\"@isDisabled\",\"@onClick\"],[\"primary\",\"block\",[28,[37,1],[\"account.downgrade.groups.confirm_new_merged_group\"],null],[30,0,[\"isMergingGroups\"]],[30,0,[\"mergeGroups\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@hasMergedGroups\",\"@firstGroup\",\"@otherGroups\",\"group\",\"@account\"],false,[\"if\",\"t\",\"svg-jar\",\"unless\",\"word-initials\",\"each\",\"-track-array\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/downgrade/merge-groups.hbs",
    "isStrictMode": false
  });

  let MergeGroups = (_class = class MergeGroups extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "isMergingGroups", _descriptor, this);
    }

    get accountGroups() {
      return this.args.account.groups;
    }

    get linkinbioPagesCount() {
      let count = 0;
      this.accountGroups.forEach(group => count += group.linkinbioPages.length);
      return count;
    }

    get mergedGroupMediaCount() {
      let mediaItemCount = 0;
      this.accountGroups.forEach(group => {
        mediaItemCount += group.mediaItemCount;
      });
      return mediaItemCount;
    }

    willDestroy() {
      super.willDestroy(...arguments);
      this.args.unloadDeletedGroups();
    }

    mergeGroups() {
      this.isMergingGroups = true;
      this.args.mergeAllGroups(() => {}, () => {
        this.isMergingGroups = false;
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isMergingGroups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "mergeGroups", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "mergeGroups"), _class.prototype)), _class);
  _exports.default = MergeGroups;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MergeGroups);
});